import { useCsZoomState } from "../../store/CsZoomState";
import zoomImg from "../../images/contents/crosssection/zoom.png";

function ZoomControlPanel() {
  const {isXZoomEnable, isYZoomEnable, toggleZoomMode} = useCsZoomState();

  function onZoomClickHandler() {
    toggleZoomMode();
  }

  const cls = [];
  if (!isXZoomEnable) cls.push('disabled-horizontal');
  if (!isYZoomEnable) cls.push('disabled-vertical');

  return (
    <div id="cs-zoom" className={`cs-zoom-ctrl-panel ${cls.join(' ')}`}>
      <img src={zoomImg} alt="zoom mode" className="cs-zoom-ctrl-icon" onClick={onZoomClickHandler} />
    </div>
  );
}

export default ZoomControlPanel;
